<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" fill="none" viewBox="0 0 12 9">
    <path fill="#7E7E7E" d="M9.887 1.587L6 5.01 2.114 1.587c-.155-.137-.39-.122-.527.033-.136.155-.122.39.033.527l4.134 3.642c.07.062.159.093.247.093s.176-.031.247-.093l4.132-3.642c.155-.136.17-.372.034-.527-.137-.155-.373-.17-.527-.033z"/>
    <path fill="#7E7E7E" d="M10.88 0H1.12C.502 0 0 .502 0 1.12v5.924c0 .618.502 1.12 1.12 1.12h9.76c.617 0 1.12-.502 1.12-1.12V1.12C12 .502 11.498 0 10.88 0zm.373 7.044c0 .206-.167.373-.373.373H1.12c-.206 0-.373-.167-.373-.373V1.12c0-.206.167-.373.373-.373h9.76c.206 0 .373.167.373.373v5.924z"/>
  </svg>
</template>

<script>
  export default {
    name: "Mail"
  }
</script>

<style scoped>

</style>